import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../../../ReactComponent';
import moment from 'moment';
import { Warning } from '@mui/icons-material';
import ModalImpressao from '@/components/shared/ModalImpressao';

class ModalRelatorioLocalDiferenteOrgaoJudicante extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            titulo: computed,
            informacoesProcessos: computed,
            totalDeProcessos: computed,
            totalDeProcessosLocalDiferenteOrgaoJudicante: computed,
            informacoesProcessosLocalDiferenteOrgaoJudicante: computed,
            cabecalho: computed
        });
    }

    get titulo() {
        let titulo = 'Processos em local diferente do órgão judicante';

        if (this.sessaoStore.sessaoSelecionada) {
            const { tipo, orgaoJudicante } = this.sessaoStore.sessaoSelecionada;
            titulo += ' - ';
            titulo += tipo === 'O' ? 'Sessão Ordinária' : 'Sessão Extraordinária';

            titulo += ' - ';
            titulo += orgaoJudicante.descricao;

            titulo += ' - ';
            titulo += moment(
                this.sessaoStore.sessaoSelecionada.prazos.dataInicioSessaoPresencial,
                'DD-MM-YYYY-HH-mm-ss'
            ).format('DD/MM/YYYY HH:mm');

            titulo += ' - ';
            titulo += this.sessaoStore.sessaoSelecionada.descricao;
        }

        return titulo;
    }
    get informacoesProcessos() {
        return this.sessaoStore.sessaoSelecionada.processos;
    }

    get totalDeProcessos() {
        return 'Total de processos: ' + this.sessaoStore.sessaoSelecionada.processos.length;
    }

    get totalDeProcessosLocalDiferenteOrgaoJudicante() {
        return (
            'Total de processos em local diferente do órgão judicante: ' +
            this.informacoesProcessosLocalDiferenteOrgaoJudicante.length
        );
    }

    get informacoesProcessosLocalDiferenteOrgaoJudicante() {
        return this.informacoesProcessos.filter((processo) => !!processo.localIncompativelJulgamento);
    }

    getDataGeracao = () => {
        return 'Relatório gerado em ' + moment().format('DD/MM/YYYY HH:mm');
    };

    get cabecalho() {
        return (
            <Box sx={{ textAlign: 'center', mt: 1 }}>
                <Typography sx={{ justifyContent: 'center', fontWeight: 'bold' }}>{this.titulo}</Typography>
                <Typography sx={{ justifyContent: 'center' }}>{this.getDataGeracao()}</Typography>
                {
                    <Typography sx={{ justifyContent: 'center' }}>
                        {this.totalDeProcessos} / {this.totalDeProcessosLocalDiferenteOrgaoJudicante}
                    </Typography>
                }
            </Box>
        );
    }

    renderTableHead() {
        return (
            <TableHead>
                <TableRow>
                    <TableCell
                        align="center"
                        sx={{ minWidth: '320px', borderTop: '1px solid rgba(224, 224, 224, 1)' }}
                    >
                        <Typography fontWeight={'bold'}>Processo</Typography>
                    </TableCell>
                    <TableCell
                        align="center"
                        sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}
                    >
                        <Typography fontWeight={'bold'}>Local atual</Typography>
                    </TableCell>
                </TableRow>
            </TableHead>
        );
    }

    renderTableBody(processos) {
        return (
            <TableBody>
                {processos?.map(({ processo, localIncompativelJulgamento }) => (
                    <TableRow
                        key={processo.numeroCompleto}
                        sx={{ verticalAlign: 'top' }}
                    >
                        <TableCell
                            style={{ width: '320px' }}
                            align="left"
                        >
                            <Typography>{processo.numeroCompleto}</Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography>{localIncompativelJulgamento}</Typography>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        );
    }

    renderConteudo() {
        return this.informacoesProcessosLocalDiferenteOrgaoJudicante.length === 0 ? (
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center', my: 2 }}>
                <Warning sx={{ fill: 'darkorange' }} />
                <Typography sx={{ color: 'darkorange', fontWeight: 'bold', marginLeft: '8px', marginTop: '2px' }}>
                    Nenhum processo está disponível para geração do relatório.
                </Typography>
            </Box>
        ) : (
            <Table
                sx={{
                    borderLeft: '1px solid rgba(224, 224, 224, 1)',
                    borderRight: '1px solid rgba(224, 224, 224, 1)'
                }}
                stickyHeader
            >
                {this.renderTableHead()}
                {this.renderTableBody(this.informacoesProcessosLocalDiferenteOrgaoJudicante)}
            </Table>
        );
    }

    render() {
        return (
            <ModalImpressao
                open={this.observableProps.openModalImpressao}
                onClose={this.observableProps.onCloseModalImpressao}
                titulo={this.titulo}
                cabecalho={this.cabecalho}
                conteudo={this.renderConteudo()}
            />
        );
    }
}

export default inject('stores')(observer(ModalRelatorioLocalDiferenteOrgaoJudicante));
